<template>
    <div class="news-form-page">
        <el-card>
            <el-collapse v-model="activeNames">
                <el-collapse-item title="基础信息" name="1">
                    <el-card  class="box-card">
                        <cl-form :model="newsModel" :fields="field" label-width="100px"
                                 :btnShowSubmit="false" :btnShowReset="false" :btnShowCancal="false"
                                 :btnDoSubmit="newsSubmit" :btnDoReset="btnReset" :pageload="pageload" >
                            <cl-form-row class="fn-clear">
                                <div slot="deptCode" ref="deptCode">
                                    <el-input v-model="newsModel.deptCode" v-show="false"></el-input>
                                    <treeselect
                                            :normalizer="deptNormalizer" :show-count="true"
                                            @select="deptSelected" v-model="deptCode"
                                            :max-height="300"
                                            :default-expand-level="1"
                                            :disable="false"
                                            :disabled="newsId!== -1"
                                            :options="deptOptions[0].children" :valueFormat="valueFormat"
                                            noOptionsText="暂无数据" placeholder="请选择所属机构"/>
                                </div>
                                <div slot="catalogId" ref="catalogId">
                                    <el-input v-model="newsModel.catalogId" v-show="false"></el-input>
                                    <treeselect slot="catalogId" ref="catalogId"
                                                @select="treeNodeClickAddNews"
                                                :default-expand-level="1" v-model="newsModel.catalogId"
                                                :normalizer="normalizer"
                                                :closeOnSelect="closeOnSelect"
                                                :show-count="true"
                                                :options="treeData1"
                                                :disable="false"
                                                :disabled="newsId!== -1"
                                                placeholder="请选择栏目" noResultsText="没有您搜索的栏目信息"/>
                                </div>
                            </cl-form-row>
                            <cl-form-row class="fn-clear">
                                <el-input ref="title" slot="title" v-model="newsModel.title" placeholder="请输入新闻标题"></el-input>
                                <el-input ref="subTitle" slot="subTitle" v-model="newsModel.subTitle" placeholder="请输入新闻副标题"></el-input>
                            </cl-form-row>
                            <cl-form-row class="fn-clear">
                                <el-input ref="shortTitle" slot="shortTitle" v-model="newsModel.shortTitle" placeholder="请输入新闻短标题"></el-input>
                                <el-input ref="source" slot="source" v-model="newsModel.source" placeholder="请输入新闻来源"></el-input>
                            </cl-form-row>
                            <cl-form-row class="fn-clear">
                                <el-input ref="author" slot="author" v-model="newsModel.author" placeholder="请输入新闻作者"></el-input>
                                <el-radio-group ref="sourceType" slot="sourceType" v-model="newsModel.sourceType">
                                    <el-radio :label=1>原创</el-radio>
                                    <el-radio :label=2>转载</el-radio>
                                    <el-radio :label=3>呈送</el-radio>
                                </el-radio-group>
                            </cl-form-row>
                            <cl-form-row class="fn-clear">
                                <div ref="label" slot="label">
                                    <RelateTags :requestUrl="requestUrl" :requestParams="requestParams"
                                                :selectedData="newsModel.label" @finalData="finalData" :limit="limit"
                                                class="RelateTagsClass">
                                    </RelateTags>
                                </div>
                            </cl-form-row>
                            <cl-form-row class="fn-clear">
                                <el-input ref="description" slot="description" v-model="newsModel.description"  type="textarea" :rows="5" resize="none" placeholder="请输入新闻摘要"></el-input>
                            </cl-form-row>
                            <cl-form-row>
                                <div ref="fileVerify" slot="fileVerify">
                                    <el-input v-model="newsModel.fileVerify" v-show="false"></el-input>
                                    <!--<span class="avatar-uploader" ref="material" slot="material">-->
                                    <!--<el-button type="primary" @click="showMaterial">点击上传</el-button>-->
                                    <!--<div tabindex="0" class="el-upload el-upload&#45;&#45;text">-->
                                    <!--<img v-if="materials.length>0"-->
                                    <!--:src="this.GLOBAL.fileBaseUrl+materials[0].coverImageUrl" class="avatar">-->
                                    <!--<i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
                                    <!--</div>-->
                                    <!--</span>-->
                                    <el-upload class="avatar-uploader"
                                               :action="'/api/zuul/wtcp-material/uploads/material/file'"
                                               :on-preview="handlePreview"
                                               :on-remove="handleRemove"
                                               :on-success="handleUploadSuccess"
                                               :before-upload="beforeUpload"
                                               :on-exceed="handleLimit"
                                               :file-list="fileList">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip">只能上传doc、docx、xls、xlsx、ppt、pptx、pdf、txt、zip、rar文件，且不超过100MB</div>
                                    </el-upload>
                                </div>
                                <!--<span class="avatar-uploader" ref="material" slot="material">-->
                                <!--<el-button type="primary" @click="showMaterial">点击上传</el-button>-->
                                <!--<div tabindex="0" class="el-upload el-upload&#45;&#45;text">-->
                                <!--<img v-if="materials.length>0"-->
                                <!--:src="this.GLOBAL.fileBaseUrl+materials[0].coverImageUrl" class="avatar">-->
                                <!--<i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
                                <!--</div>-->
                                <!--</span>-->
                                <el-upload class="avatar-uploader" ref="material" slot="material"
                                           :action="'/api/zuul/wtcp-material/uploads/material/file'"
                                           :on-preview="handlePreview"
                                           :on-remove="handleRemove"
                                           :on-success="handleUploadSuccess"
                                           :before-upload="beforeUpload"
                                           :on-exceed="handleLimit"
                                           :file-list="fileList">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                    <div slot="tip" class="el-upload__tip">只能上传doc、docx、xls、xlsx、ppt、pptx、pdf、txt、zip、rar文件，且不超过100MB</div>
                                </el-upload>
                            </cl-form-row>
                        </cl-form>
                    </el-card>
                    <!-- 素材库关联弹层 -->
                    <tabBoxs :modelType='modelType' :principalId="principalId"
                             :boxUrl="boxUrl" @cancalBtn="cancalBtn" diawidth="53%" @saveBtnArr="saveBtnArr"
                             @beforeClose="cancalBtn" v-if="materialOpen" :open="materialOpen" :totalCheckbox="1" tabTypeShow="file"></tabBoxs>
                </el-collapse-item>
                <el-collapse-item class="newsBorder" title="扩展信息" name="2" v-show="datalist.length>0">
                    <el-card>
                        <Evautoformmini  ref='Evautoformminis':forms="form" :type=formType :datalist=datalist></Evautoformmini>
                    </el-card>
                </el-collapse-item>
            </el-collapse>
        </el-card>
        <div style="margin-top: 33px;margin-left: 43%;">
            <el-button type="primary" size="small" @click="okSubmit">提交</el-button>
            <el-button type="primary" size="small" @click="addformcancle">取消</el-button>
        </div>
    </div>
</template>
<script>
    import treeselect from "@riophae/vue-treeselect";
    import "@riophae/vue-treeselect/dist/vue-treeselect.css";

    export default {
        components: {treeselect},
        data() {
            const _this = this;
            const ruleName = function (rule, value, callback) {
                debugger;
                if(_this.newsModel.catalogId !=null && _this.newsModel.catalogId != ''){
                    debugger;
                    _this.request.get("/wtcp-cms/news/existByTitleAndCatalogId", {
                        id: _this.newsId,
                        title: _this.newsModel.title,
                        catalogId: _this.newsModel.catalogId,
                        deptCode: _this.newsModel.deptCode
                    }).then(res => {
                        if (res.status == 1) {
                            return callback();
                        } else {
                            callback(new Error(res.msg));
                        }
                    });
                }else{
                    callback(new Error('请先选择新闻所属栏目'));
                }

            };
            return {
                activeNames: ["1", "2"],
                formType:3,
                datalist:[],
                form:{},

                fileList:[],

                /** 素材库开始 **/
                modelType:"upload",
                principalId:"",
                materialOpen:false,
                materialOpen:false,
                boxUrl:{
                    getMatepageList: "/wtcp-material/material/page",
                    getMateNewList: "/wtcp-cms/material/findByPidAndType",
                    getSizeAndType: "/wtcp-material/uploads/getSizeAndType",
                    saveBatch: "/wtcp-material/material/saveBatch",
                    noRightTree: "/wtcp-kb/tags/noRightTree",
                    material: "/wtcp-cms/material/",
                    saveBtns:'wtcp-cms/material/batchInsert',
                    getdelete:"/wtcp-cms/material",
                    identificaUrl:'/wtcp-cms/material/updateImgIdentify',
                    getMaterialType:'/wtcp-bics/material/getMaterialType'
                },
                /** 素材库结束 **/


                newsId: -1,
                newsModel: {
                    id:'',
                    catalogId:null,
                    catalogCode:'',
                    code:'',
                    type:4,//附件新闻
                    title:'',
                    subTitle:'',
                    shortTitle:'',
                    titleImage:'',
                    link:'',
                    description:'',
                    sourceType:1,
                    source:'',
                    author:'',
                    headline:'',
                    recommend:'',
                    top:'',
                    carousel:'',
                    clickNum:'',
                    status:'',
                    lastIssue:'',
                    deptCode:'',
                    content:'',
                    label:[],
                    timeId:'',
                    fileVerify: ''
                },
                deptCode:null,
                field: {
                    row1: [
                        {
                            name: "deptCode",
                            label: "组织机构",
                            span: 12,
                            rules: [{
                                required: true,
                                message: "请选择组织机构",
                                trigger: "change"
                            }]
                        },
                        {
                            name: "catalogId",
                            label: "所属栏目",
                            span: 12,
                            rules: [{
                                required: true,
                                message: "请选择所属栏目",
                                trigger: "change"
                            }]
                        }
                    ],
                    row2: [
                        {
                            name: "title",
                            label: "新闻标题",
                            span: 12,
                            rules: [
                                {
                                    required: true,
                                    message: "请输入新闻标题",
                                    trigger: "blur"
                                }, {
                                    max: 200,
                                    message: "长度不能超过200个字符",
                                    trigger: "blur"
                                },
                                {
                                    type: "string",
                                    pattern: this.regex.noHtml,
                                    message: "只允许输入纯文本、符号",
                                    trigger: "blur"
                                },
                                {
                                    type: "string",
                                    validator: ruleName,
                                    trigger: "blur"
                                }
                                ]
                        },
                        {
                            name: "subTitle",
                            label: "副标题",
                            span: 12,
                            rules: [{
                                max: 200,
                                message: "长度不能超过200个字符",
                                trigger: "blur"
                            },{
                                type: "string",
                                pattern: this.regex.noHtml,
                                message: "只允许输入纯文本、符号",
                                trigger: "blur"
                            }]
                        }

                    ],
                    row3: [
                        {
                            name: "shortTitle",
                            label: "短标题",
                            span: 12,
                            rules: [{
                                max: 200,
                                message: "长度不能超过200个字符",
                                trigger: "blur"
                            },{
                                type: "string",
                                pattern: this.regex.noHtml,
                                message: "只允许输入纯文本、符号",
                                trigger: "blur"
                            }]
                        },
                        {
                            name: "source",
                            label: "新闻来源",
                            span: 12,
                            rules: [{
                                max: 50,
                                message: "长度不能超过50个字符",
                                trigger: "blur"
                            },{
                                type: "string",
                                pattern: this.regex.noHtml,
                                message: "只允许输入纯文本、符号",
                                trigger: "blur"
                            }]
                        }
                        ,
                    ],
                    row4: [
                        {
                            name: "author",
                            label: "新闻作者",
                            span: 12,
                            rules: [{
                                max: 50,
                                message: "长度不能超过50个字符",
                                trigger: "blur"
                            },{
                                type: "string",
                                pattern: this.regex.noHtml,
                                message: "只允许输入纯文本、符号",
                                trigger: "blur"
                            }]
                        }
                        ,{
                            name: "sourceType",
                            label: "来源类型",
                            span: 12,
                            rules: [
                                {
                                    required: true,
                                    message: "请选择来源类型",
                                    trigger: "blur"
                                }
                            ]

                        }
                    ],
                    row5: [
                        {
                            name: "label",
                            label: "新闻标签",
                            span: 24
                        }
                    ],
                    row6: [
                        {
                            name: "description",
                            label: "新闻摘要",
                            span: 24,
                            rules: [{
                                max: 512,
                                message: "长度不能超过512个字符",
                                trigger: "blur"
                            },{
                                type: "string",
                                pattern: this.regex.noHtml,
                                message: "只允许输入纯文本、符号",
                                trigger: "blur"
                            }]
                        }
                    ],
                    row7: [
                        {
                            name: "fileVerify",
                            label: "上传附件",
                            span: 24,
                            rules: [
                                {
                                    required: true,
                                    message: "请选择上传附件",
                                    trigger: "change"
                                }
                            ]
                        }
                    ]
                },

                deptOptions: [{
                    id: 0,
                    name: "组织机构信息",
                    level: null,
                    children: []
                }],
                valueFormat: "label",

                deptNormalizer(node) {
                    return {
                        id: node.code,
                        label: node.name,
                        children:
                            node.children && node.children.length > 0 ? node.children : node.level == 1 ? null : "null"
                    };
                },

                normalizer(node) {
                    return {
                        id: node.id.toString(),
                        code: node.code,
                        label: node.name,
                        children: node.children && node.children.length > 0 ? node.children : "null",
                    };
                },

                finalData(data) {

                    _this.newsModel.label = data;
                },

                pageload:false,
                treeNodeClickAddNews(node, data) {
                    _this.newsModel.catalogCode = node.code;
                    if(!node.leaf){
                        _this.$message.error('只能选择没有子级的栏目！');
                        _this.newsModel.catalogId = null;
                        return;
                    }
                    _this.getExtendInfoByPrincipalId(node.id);
                },
                closeOnSelect:false,
                treeData1: [{
                    label: "新闻栏目",
                    expand: false,
                    id: 0,
                    level: 0,
                    leaf: false,
                    name: "新闻栏目",
                    title: "新闻栏目",
                    code: null,
                    children: []
                }],
                //标签地址
                requestUrl: "/wtcp-kb/tags/getTagsByKind",
                requestParams: {kind: 8},
                limit: 9,

                tempId: "",
                materials:[]
            };
        },
        methods: {
            okSubmit(){
                this.$refs.Evautoformminis.$refs.form.validate(valid => {
                    if (valid) {
                        let _this = this;
                        let e = _this.newsModel
                        let list = [];
                        for (let i = 0; i < e.label.length; i++) {
                            let n = {
                                principalId: e.id,
                                tagCatagory: e.label[i].pName,
                                tagName: e.label[i].name
                            };
                            list.push(n);
                        }

                        let params = {
                            newsTags: list,
                            news: e,
                            extendMap:this.$refs['Evautoformminis'].submititem2(),
                            newsMaterials: _this.materials
                        };
                        if (_this.newsId === -1) {
                            _this.pageload = true;
                            _this.request.post("/wtcp-cms/annexNews/save", params).then(res => {
                                if (res.status === 1) {
                                    _this.$message.success(res.msg);
                                    // _this.$router.back(-1);
                                    _this.$router.push({
                                        name: 'wtcp-cms-bnsgl',
                                        query: {
                                            deptCode: _this.newsModel.deptCode
                                        }
                                    });
                                } else {
                                    _this.$message.error("新增失败:" + res.msg);
                                }
                                _this.pageload = false;
                            });
                        } else {
                            this.request.put("/wtcp-cms/annexNews/" + _this.newsId, params)
                                .then(res => {
                                    if (res.status === 1) {
                                        _this.$message.success(res.msg);
                                        // this.$router.back(-1);
                                        _this.$router.push({
                                            name: 'wtcp-cms-bnsgl',
                                            query: {
                                                deptCode: _this.newsModel.deptCode
                                            }
                                        });
                                    } else {
                                        _this.$message.error("编辑失败:" + res.msg);
                                    }
                                    _this.pageload = false;

                                });
                        }
                    } else {
                        return false;
                    }
                });
            },
            addformcancle(filedList,data){
                // this.$router.push({  name: 'wtcp-cms-bnsgl'});
                this.$router.push({
                    name: 'wtcp-cms-bnsgl',
                    query: {
                        deptCode: this.newsModel.deptCode
                    }
                });
            },

            //文件上传成功回调
            handleUploadSuccess (res, file) {
                res.data.forEach(d=>{
                    let material = {};
                    material.fileType = d.fileType;
                    material.fileUrl = d.filePath;
                    material.fileIdentify = '';
                    material.coverImageUrl = '';
                    material.fileName = d.fileName;
                    this.newsModel.fileVerify = d.filePath.toString();
                    this.materials.push(material);
                })
            },
            //上传文件之前
            beforeUpload (file) {
                let fileType = file.name.substring(file.name.indexOf('.')+1,file.name.length);
                let okType = 'doc、docx、xls、xlsx、ppt、pptx、pdf、txt、zip、rar';
                if(okType.indexOf(fileType) !=-1){
                    const limitSize = file.size / 1024 / 1024 < 100;
                    if (!limitSize) {
                        this.$message.error('上传文件大小不能超过 100MB!');
                        return false;
                    }
                }else{
                    this.$message.error('上传文件只能是doc、docx、xls、xlsx、ppt、pptx、pdf、txt、zip、rar格式!');
                    return false;
                }
            },


            // 文件列表移除文件时
            handleRemove(file, fileList) {
                let ma = [];
                debugger;
                this.materials.forEach(m=>{
                    if(m.fileUrl != file.url){
                        ma.push(m)
                    }
                });
                console.log(fileList + "*****************");
                if(fileList == ""){
                    this.newsModel.fileVerify = ''
                }
                this.materials  = ma;
            },
            handlePreview(file) {},
            handleLimit(files, fileList) {
                // this.$message.warning(`当前限制只能上传 1个文件，本次选择了 ${files.length} 个文件`);
                // return false
            },


            //素材相关方法start
            saveBtnArr(data){
                let _self = this;
                let keys = Object.keys(data);
                if(keys.length == 0){
                    _self.$message.error("至少选择一条附件类的素材");
                }else if(keys.length >1){
                    _self.$message.error("只能选择一条附件类的素材");
                }else {
                    _self.materials = [];
                    Object.keys(data).forEach(function(key){
                        if(data[key].fileType == "video"){
                            let material = {};
                            material.materialId = data[key].id;
                            material.fileType = data[key].fileType;
                            material.fileUrl = data[key].fileUrl;
                            material.fileIdentify = data[key].fileIdentify?data[key].fileIdentify:'';
                            material.coverImageUrl = data[key].coverUrl;
                            material.fileName = data[key].fileName;
                            _self.materials.push(material);
                        }
                    });
                }
                _self.materialOpen = false;
            },
            showMaterial(){
                this.materialOpen = true;
            },
            cancalBtn(){
                this.materialOpen = false;
            },
            //素材相关方法end

            newsSubmit() {
                let _this = this;
                let e = _this.newsModel
                let list = [];
                for (let i = 0; i < e.label.length; i++) {
                    let n = {
                        principalId: e.id,
                        tagCatagory: e.label[i].pName,
                        tagName: e.label[i].name
                    };
                    list.push(n);
                }
                let params = {
                    newsTags: list,
                    news: e,
                    newsMaterials:_this.materials
                };

                if (_this.newsId === -1) {
                    _this.pageload = true;
                    _this.request.post("/wtcp-cms/annexNews/save", params).then(res => {
                        if (res.status === 1) {
                            _this.$message.success(res.msg);
                            // _this.$router.back(-1);
                            _this.$router.push({
                                name: 'wtcp-cms-bnsgl',
                                query: {
                                    deptCode: _this.newsModel.deptCode
                                }
                            });
                        } else {
                            _this.$message.error("新增失败:" + res.msg);
                        }
                        _this.pageload = false;
                    });
                } else {
                    this.request.put("/wtcp-cms/annexNews/" + _this.newsId, params)
                        .then(res => {
                            if (res.status === 1) {
                                _this.$message.success(res.msg);
                                // this.$router.back(-1);
                                _this.$router.push({
                                    name: 'wtcp-cms-bnsgl',
                                    query: {
                                        deptCode: _this.newsModel.deptCode
                                    }
                                });
                            } else {
                                _this.$message.error("编辑失败:" + res.msg);
                            }
                            _this.pageload = false;

                        });
                }
            },
            btnReset() {
                this.request.get("/wtcp-cms/news/" + this.newsId).then(res => {
                    if (res.status === 1) {
                        this.newsModel = res.data.news;
                        this.newsId = res.data.news.id;

                        let array = [];
                        res.data.newsTags.forEach(tag=>{
                            array.push({name: tag.tagName, pName: tag.tagCatagory})
                        })
                        this.newsModel.label = array;
                    }
                });
            },
            relationKey(data) {
                for (let i in data) {
                    this.relationKey(data[i].children);
                    data[i].title = data[i].label = data[i].name;
                }
                return data;
            },
            getDeptTreeData() {
                let that = this;
                that.request.get("/wtcp-oauth/dept/getAllDeptTree").then(res => {
                    debugger;
                    if (res.status === 1) {
                        that.deptOptions[0].children = res.data;
                        if(that.newsModel.deptCode != null){
                            that.deptCode = {
                                code: that.newsModel.deptCode
                            };
                            this.getCatalogTreeData();
                        }
                    } else {
                        that.$message.error(res.msg);
                    }
                });
            },
            deptSelected(node, instanceId) {
                debugger;
                this.newsModel.deptCode = node.code;
                this.getCatalogTreeData();
            },
            getCatalogTreeData() {
                let that = this;
                that.request.get("/wtcp-cms/newsCatalog/getAllTree",{deptCode:that.newsModel.deptCode}).then(res => {
                    if (res.status === 1) {
                        that.treeData1[0].children = that.relationKey(res.data);
                        let arr = JSON.parse(JSON.stringify(that.treeData1));
                        for (let i = 0; i < arr[0].children.length; i++) {
                            arr[0].children[i].children = [];
                        }
                        that.treDataAdd = arr;
                        that.addOrEdit();
                    } else {
                        that.$message.error(res.msg);
                    }
                });
                if(this.newsModel.catalogId !=undefined &&
                    this.newsModel.catalogId!=null &&
                    this.newsModel.catalogId!=''){
                    this.getExtendInfoByPrincipalId(this.newsModel.catalogId);
                }
            },
            //新增、修改、重置
            addOrEdit() {
                let _this = this;
                if (this.newsId !== -1) {
                    this.request.get("/wtcp-cms/news/" + _this.newsId).then(res => {
                        if (res.status === 1) {
                            _this.deptCode = {
                                code : res.data.news.deptCode
                            }
                            _this.newsModel = res.data.news;
                            _this.newsId = res.data.news.id;
                            res.data.newsMaterials.forEach(newMaterial=>{
                                let m = {};
                                m.name = newMaterial.fileName;
                                m.url = newMaterial.fileUrl;
                                _this.fileList.push(m)
                            });
                            this.materials  = res.data.newsMaterials;
                            this.newsModel.fileVerify = res.data.newsMaterials[0].fileUrl.toString();
                            let array = [];
                            res.data.newsTags.forEach(tag=>{
                                array.push({name: tag.tagName, pName: tag.tagCatagory})
                            })
                            _this.newsModel.label = array;
                            _this.form = res.data.extendMap;
                            _this.getExtendInfoByPrincipalId( _this.newsModel.catalogId);
                        }
                    });
                }
            },
            getExtendInfoByPrincipalId(principalId){
                var _this = this;
                this.request.get("/wtcp-material/formGroup/findByPrincipalId/"+principalId).then(res => {
                    if(res.status == 1){
                        if (res.data.list != undefined && res.data.list != null ) {
                            let dataList = [];
                            res.data.list.forEach(data=>{
                                if(data.optional !=null & data.optional !='' && data.optional != undefined){
                                    data.optional = eval("("+data.optional+")");
                                }
                                data.requires = data.required == 1?true:false;
                                data.fieldType = data.fieldTypeName;
                                dataList.push(data)
                            });
                            _this.datalist = dataList;
                        }else{
                            _this.datalist = [];
                        }
                    }
                })
            }
        },
        created: function () {
            this.request.getAuth(this);
            this.newsId = this.$route.query.id;
            this.newsModel.catalogId = this.$route.query.catalogId ? this.$route.query.catalogId:null;
            this.newsModel.catalogCode = this.$route.query.catalogCode ? this.$route.query.catalogCode:null;
            this.newsModel.deptCode = this.$route.query.deptCode ? this.$route.query.deptCode : null;
            this.getDeptTreeData();
        }
    };
</script>
<style lang="less">
    .news-form-page {

        .newsBorder{
            .el-divider.el-divider--horizontal{
                display: none;
            }
        }

        .el-collapse-item__header {
            font-size: 16px;
            font-weight: 600;
        }


        .vue-treeselect__control {
            height: 28px !important;
        }

        .vue-treeselect__placeholder, .vue-treeselect__single-value {
            padding-left: 10px !important;
            line-height: 28px !important;
        }
    }
</style>
